import { motion } from 'framer-motion';
import { FaCertificate, FaFilePdf, FaExternalLinkAlt } from 'react-icons/fa';
import Seo from '../components/ui/Seo';
import BlurFade from '../components/ui/BlurFade';
import { certifications } from '../data/certifications';

const isPdf = (url) => url?.toLowerCase().endsWith('.pdf');

const Certificates = () => {
  return (
    <main className="bg-white pb-20 pt-32 text-black">
      <Seo
        title="Certificates | Prathamesh Shete"
        description="Certifications and training completed by Prathamesh Shete, AI/ML Engineer — LangChain, data science, and more."
        path="/certificates"
      />

      <div className="mx-auto max-w-4xl px-6">
        <BlurFade>
          <h1 className="mb-3 text-3xl font-black sm:text-4xl">
            Certificates<span className="text-black/30">.</span>
          </h1>
        </BlurFade>
        <BlurFade delay={0.05}>
          <p className="mb-10 text-black/60">Verified certifications and training completed over the years.</p>
        </BlurFade>

        <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2">
          {certifications.map((cert, i) => {
            const Content = (
              <motion.div
                whileHover={cert.fileUrl ? { y: -4, boxShadow: '0 8px 0 0 rgba(0,0,0,1)' } : undefined}
                className="flex h-full flex-col gap-3 rounded-xl border-2 border-black p-5"
              >
                <div className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-black text-white">
                    {cert.fileUrl && isPdf(cert.fileUrl) ? <FaFilePdf size={14} /> : <FaCertificate size={14} />}
                  </span>
                  <div className="flex-1">
                    <h2 className="font-black leading-tight">{cert.title}</h2>
                    {cert.issuer && <p className="text-sm text-black/60">{cert.issuer}</p>}
                  </div>
                  {cert.fileUrl && <FaExternalLinkAlt size={12} className="mt-1 shrink-0 text-black/40" />}
                </div>
                <div className="mt-auto flex flex-wrap gap-2 text-xs font-semibold text-black/50">
                  {cert.date && <span>{cert.date}</span>}
                  {cert.grade && <span>&middot; {cert.grade}</span>}
                </div>
              </motion.div>
            );

            return (
              <BlurFade key={cert.title} delay={(i % 6) * 0.04} className="h-full">
                {cert.fileUrl ? (
                  <a href={cert.fileUrl} target="_blank" rel="noopener noreferrer" className="block h-full">
                    {Content}
                  </a>
                ) : (
                  Content
                )}
              </BlurFade>
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default Certificates;
